import markUrl from '@shop/logo-mark.png'
import lockupUrl from '@shop/logo-full.png'
import { shop } from '../lib/shop'

/**
 * The shop mark: the gold W with the flower growing through it.
 *
 * A bitmap rather than inline SVG, because the mark is a piece of artwork with
 * a metallic gradient down every stroke - drawing that by hand would be a worse
 * copy of something that already exists. It also survives the trip into a PDF
 * better than the old inline drawing did: html2canvas serialises an SVG away
 * from the page and loses anything inherited from it, while an image is simply
 * an image.
 *
 * Gold is made to sit on something dark. On the letterhead and the login plate
 * it has that; anywhere pale, it reads as a faint smudge - so those are the
 * only two places it is used.
 */
export function FlowerMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src={markUrl}
      alt=""
      aria-hidden="true"
      /* 288x256 in the source; height drives the size, width follows it. */
      height={size}
      width={Math.round(size * 1.125)}
      draggable={false}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  )
}

/**
 * The full lockup - the mark and the shop's name together - for the places that
 * are nothing but the shop introducing itself: the login plate, and the top of
 * every bill.
 *
 * <p>Both dimensions are written out, because an image that declares only its
 * width reserves no space until it loads and the bill jumps as it arrives. The
 * proportion comes from the shop, not from a constant: Uzair's artwork is
 * near-square and stacked, and a wide lockup put through his ratio would be
 * squashed into a strip.
 */
export function ShopLockup({ width = 300 }: { width?: number }) {
  return (
    <img
      className="lockup"
      src={lockupUrl}
      alt={shop.name}
      width={width}
      height={Math.round(width * shop.lockupRatio)}
      draggable={false}
    />
  )
}
